import { SmartphotoImageBase } from './smartphoto-image-base.class';
export class SmartphotoBase {
    id = '0';
    master_company_id = '1';
    attributes = {
        costEstimationActive: false,
        country: 'ES',
        picturesQuality: {},
        companyStatus: '',
        AIActive: false,
        damageDetectionActive: false,
        vertical: 'Motor',
        '360PicturesActive': false,
        deductibleAddOnActive: false,
        estimationProvider: 'bdeo-estimate',
        useCase: 'Claim',
        creationChannel: 'admin',
        claimDamagesActive: false,
        screenShotsAddOnActive: false,
        executionChannel: 'Selfadjust'
    };
    alerts = {
        rt: false
    };
    notificationChannel;
    notifications = [];
    selfadjustProgress;
    template;
    statusIndex;
    lat;
    lng;
    remote_web_device = {};
    numRef = 'numRef';
    caseRef = 'caseRef';
    images = [];
    damageSummary = [];
    costEstimationInfo;
    status = 0;
    constructor(base = {}) {
        Object.entries(base).forEach(([key, value]) => {
            this[key] = value ?? this[key];
        });
        this.images = (base.images || []).map((image) => new SmartphotoImageBase(image));
    }
}
